import { render, staticRenderFns } from "./AddAttributeGroupComponent.vue?vue&type=template&id=3dd0698e&scoped=true"
import script from "./AddAttributeGroupComponent.vue?vue&type=script&lang=js"
export * from "./AddAttributeGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd0698e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd0698e')) {
      api.createRecord('3dd0698e', component.options)
    } else {
      api.reload('3dd0698e', component.options)
    }
    module.hot.accept("./AddAttributeGroupComponent.vue?vue&type=template&id=3dd0698e&scoped=true", function () {
      api.rerender('3dd0698e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/AddAttributeGroupComponent.vue"
export default component.exports